import Vue from 'vue';
import Vuex from 'vuex';

import permission from './modules/permission'
import {
	getUserMenu
} from '@/api/pemission'
import {
	resetRouter
} from '@/router'
import common from '@/utils/util'
import {
	userWXLogin
} from '@/api/basisMG'
// import getters from './getters'
Vue.use(Vuex);


// 登录验证
export default new Vuex.Store({
	modules: {

		permission
	},
	//   getters,
	state: {
		user: false,
		menuList: [],
		getmenuList: [],
		tabsList: [{
			path: '/index',
			name: '首页',
			label: '首页',
			icon: 'home',
			meta: {
				requireAuth: true,
				title: "首页"
			}
		}],
		listPagePars: new Map(),
	},
	getters: {
		menuList: state => state.menuList,
		getmenuList: state => state.getmenuList,
	},
	mutations: {
		saveParam(state, {
			path,
			pars
		}) {
			console.log(path)
			state.listPagePars.set(path, pars);
			sessionStorage.setItem("listPagePars", state.listPagePars);
		},
		// 登录
		login(state, user) {
			state.user = user;
			sessionStorage.setItem("user", user);
		},

		// 退出
		logout(state) {
			state.user = "";

			sessionStorage.setItem("user", "");
			sessionStorage.setItem('uid', '')
			resetRouter()

		},
		getmenu(state, menu) {
			state.menuList = menu;


		},
		getmenuList(state, getmenuList) {

			state.getmenuList = getmenuList;
		},
		// getUserMenuList(state,uid){
		//     getUserMenu({uid}).then(response=>{ 
		//       state.menuList = response.data;

		//    })
		//   },
		//关闭标签页
		closeTab(state, val) {
			let result = state.tabsList.findIndex(item => item.path === val.path)
			let res = state.tabsList[result]
			state.tabsList.splice(result, 1)
			state.listPagePars.set(res.path, {
				start: 0,
				length: 10,
			});
			sessionStorage.setItem("listPagePars", state.listPagePars);
			sessionStorage.setItem("tabsList", state.tabsList);
		},
		selectMenu(state, val) {
			// console.log('store', val)
			// console.log( state.tabsList )
			if (val && val.path !== '/index') {
				state.currentMenu = val

				//找不到就返回 -1
				let result = state.tabsList.findIndex(item => item.path === val.path)

				result === -1 ? state.tabsList.push(val) : ''
				// sessionStorage.setItem('store', JSON.stringify(this.$store.state));
			} else {
				state.currentMenu = null
			}


		},
	},
	actions: {
		saveListPagePars ({
			commit
		}, {
			path,
			pars
		}) {
			commit('saveParam', {
				path,
				pars
			});
		},
		getUserMenuList({
			commit
		}, uid) {
			return new Promise((resolve, reject) => {
				getUserMenu({
					uid
				}).then(response => {
					let menuList = response.data;

					if (menuList && menuList.length) {
						commit('getmenu', common.getRoutes(menuList))
						commit('getmenuList', menuList)
						resolve(common.getRoutes(menuList))
					} else {
						commit('logout', true)
						resolve(null)
					}
					// console.log('common',common.getRoutes(menuList))

				}).catch(error => {
					reject(error)
					commit('logout', true)
				})
			})


		},
		touserWXLogin({
			commit
		}, code) {
			return new Promise((resolve, reject) => {
				userWXLogin({
					code
				}).then(res => {
					sessionStorage.setItem('uid', res.data.uid)
					sessionStorage.setItem('username', res.data.username)

					sessionStorage.setItem('userdata', JSON.stringify(res.data))

					commit('login', JSON.stringify(res.data))
					// console.log('common',common.getRoutes(menuList))

					resolve(JSON.stringify(res.data))
				}).catch(error => {
					reject(error)
				})
			})
		}


	}
})
